import { render, staticRenderFns } from "./SignatureDetailsPage.vue?vue&type=template&id=60e8846a&scoped=true&"
import script from "./SignatureDetailsPage.vue?vue&type=script&lang=js&"
export * from "./SignatureDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./SignatureDetailsPage.vue?vue&type=style&index=0&id=60e8846a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8846a",
  null
  
)

export default component.exports